export const toCamelCase = (str) => {
  if (!str || typeof str !== 'string') return str;
  
  // Handle snake_case
  if (str.includes('_')) {
    return str
      .split('_')
      .map((word, index) => {
        if (index === 0) {
          return word.toLowerCase();
        }
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join('');
  }
  
  // Handle ALL-CAPS acronyms (e.g. "ID", "GUID", "URL")
  if (str === str.toUpperCase() && str !== str.toLowerCase()) {
    return str.toLowerCase();
  }
  
  // Handle PascalCase
  if (str.charAt(0) === str.charAt(0).toUpperCase()) {
    return str.charAt(0).toLowerCase() + str.slice(1);
  }
  
  // Already camelCase
  return str;
};

export const objectToCamelCase = (obj) => {
  if (obj === null || obj === undefined) {
    return obj;
  }
  
  // Handle arrays
  if (Array.isArray(obj)) {
    return obj.map(item => objectToCamelCase(item));
  }
  
  // Handle non-object primitives
  if (typeof obj !== 'object') {
    return obj;
  }
  
  // Handle Date objects
  if (obj instanceof Date) {
    return obj;
  }
  
  // Convert object keys
  const converted = {};
  
  Object.keys(obj).forEach((key) => {
    const camelKey = toCamelCase(key);
    converted[camelKey] = objectToCamelCase(obj[key]);
  });
  
  return converted;
};

export const toSnakeCase = (str) => {
  if (!str || typeof str !== 'string') return str;
  
  return str
    .replace(/([A-Z])/g, '_$1')
    .toLowerCase()
    .replace(/^_/, '');
};

export const toPascalCase = (str) => {
  if (!str || typeof str !== 'string') return str;
  
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const detectCase = (str) => {
  if (!str || typeof str !== 'string') return 'unknown';
  
  if (str.includes('_')) return 'snake_case';
  if (str.charAt(0) === str.charAt(0).toUpperCase()) return 'PascalCase';
  if (str.charAt(0) === str.charAt(0).toLowerCase() && /[A-Z]/.test(str)) return 'camelCase';
  
  return 'unknown';
};

export default {
  toCamelCase,
  objectToCamelCase,
  toSnakeCase,
  toPascalCase,
  detectCase,
};